import React from 'react'
import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'


import Button from '@material-ui/core/Button/Button'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'

export default class extends React.Component {

  state = {
    liaision_chambres: [],
    connection: '',
    nokeys_verrous: [],
  }

  async componentDidMount () {
    const nokeysLiaision = await ApiRequest(project.api + 'interface', {
      action: 'get',
      requete: 'nokeys',
    })

    if (nokeysLiaision && nokeysLiaision.code === 1) {
      let nokeys_verrous = []
      if (nokeysLiaision.results.connection) {
        const nokeysVerrous = await ApiRequest('https://partnerapi.igloohome.co/v1/locks', {}, {
          method: 'GET',
          notSetToken: true,
          returnAnyway: true
        }, {
          'X-IGLOOHOME-APIKEY': nokeysLiaision.results.connection,
        })
        nokeys_verrous = nokeysVerrous
      }

      this.setState({
        connection: nokeysLiaision.results.connection,
        liaision_chambres: nokeysLiaision.results.chambres || [],
        nokeys_verrous: nokeys_verrous,
      })
    }

  }

  onChangeVerrouLinked = (i, verrou_id) => (data) => {
    const liaision_chambres = this.state.liaision_chambres
    if (i === -1) {
      liaision_chambres.push({
        verrou_id: verrou_id,
        numero: data
      })
    } else if (data === undefined) {
      liaision_chambres.splice(i, 1)
    } else {
      liaision_chambres[i] = {
        verrou_id: verrou_id,
        numero: data
      }
    }

    this.setState({
      liaision_chambres: liaision_chambres
    })
  }

  onChangeConnection = (data) => {
    this.setState({
      connection: data
    })
  }

  handleSave = async () => {
    await ApiRequest(project.api + 'interface', {
      action: 'set',
      requete: 'nokeys',
      chambres: this.state.liaision_chambres.filter(lp => lp.verrou_id !== undefined),
      connection: this.state.connection,
    })

    if (this.state.connection) {
      const nokeysVerrous = await ApiRequest('https://partnerapi.igloohome.co/v1/locks', {}, {
        method: 'GET',
        notSetToken: true,
        returnAnyway: true
      }, {
        'X-IGLOOHOME-APIKEY': this.state.connection,
      })
      this.setState({
        nokeys_verrous: nokeysVerrous
      })
    }
  }

  render () {
    return (
      <EurestoDiv
        title={
          <Button variant={
            'contained'
          }
                  size="small"
                  onClick={
                    this.handleSave
                  }
                  className={
                    ('EurestoPrimary')
                  }> &nbsp;
            <i className={'ei-commun_valider EurestoSecondary--text'}/> &nbsp;
            <span className={'EurestoText--text'}>{'Enregistrer'}</span> &nbsp;
          </Button>}>
        <Grid container style={{ margin: 0, padding: 20, width: '100%', position: 'relative' }}
              spacing={0} justify={'center'} alignContent={'center'} alignItems={'stretch'} direction={'column'}>
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Input onChange={this.onChangeConnection} inlineWidth={80} name='code' type='text' inline className='upText'
                   value={this.state.connection}
                   title={EurestoI18n.t('crm:Connexion')}/>
          </Grid>
          {
            this.state.nokeys_verrous && this.state.nokeys_verrous.length > 0 &&
            <Grid item xs={12} sm={8} md={6} lg={4}>
              <Grid container style={{ margin: 0, padding: 0, width: '100%', position: 'relative' }}
                    spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>

                <Grid item xs={12}>
                  <Grid container style={{
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    position: 'relative',
                  }} spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>
                    <Grid item xs={6} style={{
                      textAlign: 'left',
                      paddingLeft: 10,
                      borderRight: '1px solid black'
                    }}>
                      Verrou
                    </Grid>
                    <Grid item xs={6} style={{ paddingLeft: 10 }}>
                      Numéro de chambre
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  {
                    this.state.nokeys_verrous.map((verrou, i) => {
                      const chambre_index = (this.state.liaision_chambres || []).findIndex(lp => lp.verrou_id === verrou._id)
                      const chambre_linked = chambre_index !== -1 && (this.state.liaision_chambres || [])[chambre_index]
                      return <Grid container style={{
                        margin: 0,
                        padding: 0,
                        width: '100%',
                        position: 'relative',
                        border: '1px solid black',
                        borderTop: i !== 0 && 'none' || '1px solid black'
                      }} spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>
                        <Grid item xs={12}
                              style={{ padding: 0 }}>
                          <Grid container style={{
                            margin: 0,
                            padding: 0,
                            width: '100%',
                            position: 'relative',
                          }} spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>
                            <Grid item xs={6} style={{
                              textAlign: 'left',
                              paddingLeft: 10,
                              borderRight: '1px solid black'
                            }}>
                              {verrou.name}
                            </Grid>
                            <Grid item xs={6} style={{
                              padding: 10,
                            }}>
                              <Input
                                onChange={this.onChangeVerrouLinked(chambre_index, verrou._id)}
                                value={chambre_linked && chambre_linked.numero}/>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    })
                  }
                </Grid>
              </Grid>
            </Grid>
          }
        </Grid>
      </EurestoDiv>)
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Interface/Nokeys/index.js